var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAjaxLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 72,
    viewBox: "0 0 76 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1787 3.61596C8.58606 8.56768 3.7828 15.5293 1.49376 23.4504C-0.795277 31.3714 -0.445882 39.8221 2.48922 47.5272C5.42432 55.2322 10.7859 61.7736 17.7648 66.1642C24.7437 70.5548 32.9614 72.5564 41.1777 71.8669C49.394 71.1774 57.1631 67.8343 63.3127 62.342C69.4623 56.8497 73.6587 49.5062 75.2686 41.4198C76.8785 33.3333 75.8146 24.9426 72.2375 17.5138C68.6603 10.085 62.764 4.02123 55.4383 0.237503L51.0755 8.68442C56.5684 11.5215 60.9895 16.0682 63.6717 21.6384C66.3539 27.2086 67.1516 33.5001 65.9445 39.5634C64.7373 45.6268 61.5908 51.133 56.9798 55.2512C52.3687 59.3694 46.5434 61.8761 40.3827 62.3931C34.222 62.9101 28.0603 61.4093 22.8274 58.1172C17.5945 54.825 13.5743 49.9202 11.3735 44.1429C9.17276 38.3655 8.91078 32.0291 10.6271 26.0898C12.3435 20.1504 15.945 14.9305 20.8883 11.2176L15.1787 3.61596Z",
    fill: "url(#paint0_linear_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 17.7315,
    y1: 1.9476,
    x2: 86.0085,
    y2: 75.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930464,
    stopColor: "#0098FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjaxLoader);
export default __webpack_public_path__ + "static/media/ajax-loader.3b8ccb333cc87fec48ab47e283d5b701.svg";
export { ForwardRef as ReactComponent };